import storage from './storage';

/**
 * Whether the left sidebar (courses and activities, Commitments) is closed, kept in this browser. The narrow icon column
 * beside it (ColumnViews) shows the Calendar / Task List pair while it is, the sidebar's own switch being out of sight
 * (top-bar tidy, 2026-10-31), so it hears when the sidebar changes it.
 */
const listeners = new Set<(collapsed: boolean) => void>();

export const isSidebarCollapsed = () => storage.getSidebarCollapsed();

export const setSidebarCollapsed = (collapsed: boolean) => {
  storage.setSidebarCollapsed(collapsed);
  listeners.forEach(listener => listener(collapsed));
};

/** Called whenever the sidebar is opened or closed. */
export const onSidebarCollapsed = (listener: (collapsed: boolean) => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
